<template>
  <!-- { component: data, colorIndex: selectedColor, optionIndex: selectedOption, variantIndex: selectedVariant })"> -->
  <button class="button-wrapper" @click="updateSelectedData({realSelect: true})">
    <div class="card" :class="selected ? 'card-selected' : '' ">
      <div class="card-header">
        <!-- <img :src="`${previewsServer + models}previews/${data.code +  (data.options.length > 0 ? data.options[selectedOption].subCode : '')}.png`" alt="" @error="setBackupImage($event, data)"> -->
        <img :src="imgUrl" alt="">
        <!-- GLASS TYPES -->
        <!-- title = hover text over button -->
        <div class="card-header-glastypes" v-if="data.glasTypes && data.glasTypes.length > 0">
          <button 
            class="card-header-glastypes-button" 
            v-for="(glasType, index) in data.glasTypes" 
            :key="index" 
            :title="`${glasType.name} (${glasType.code})`"
            :class="cselected ? sglasType.code === glasType.code ? 'card-header-glastypes-button-active' : '' : index === selectedGlasType ? 'card-header-glastypes-button-active' : ''"
            @click="selectedGlasType = index; 
              selectedVariant = 0; 
              selectedColor = 0; 
              selectedOption = 0; 
              lastCodeSelection = glasType.code;
              $emit('select')"
            >
            <!-- {{ JSON.stringify(lastCodeSelection) }} -->
            <!-- ",{ 
              component: data, 
              glasTypeIndex: index, 
              variantIndex: 0, 
              colorIndex: 0, 
              optionIndex: 0 
              })" -->
          {{ glasType.acronym }}
          </button>
        </div>

        <!-- COLORS -->
        <!-- <div class="card-header-colors" v-if="data.colors.length > 0"> -->
          <!-- v-for="(color, index) in data.colors" -->
        <div class="card-header-colors" v-if="colors">
          <button 
            class="card-header-colors-button" 
            v-for="(color, index) in colors" 
            :key="index" 
            :title="`${color.name} (${color.code})`"
            :style="`background-color: ${color.hexCode};`"
            :class="color.id === selectedColor ? 'card-header-colors-button-active' : ''"
            @click.stop="selectedColor = color.id; updateSelectedData()"
          >
          <span>{{ color.label }}</span>
          <!-- { 
              component: data, 
              glasTypeIndex: selectedGlasType, 
              variantIndex: selectedVariant, 
              colorIndex: index, 
              optionIndex: selectedOption 
              })" -->
          </button>
        </div>
      </div>

      <!-- CARD INFO -->
      <!-- title = hover text over button -->
      <div class="card-info">
        <!-- <h3>{{ selectedColor > 0 ? data.colors[selectedColor].componentName : data.shortName }}</h3> -->
        <div class="card-info-header">
          <h3>{{ title }}</h3>
          <button
            v-if="infobox && infoboxOnline"
            class="infobox-button-specs" 
            @mouseover="specsBtnMouseOver" 
            @mouseleave="specsBtnMouseLeave"
            @click.stop="enableAndHoldSpecs()"
          >
            <div class="infobox-question-mark" style="pointer-events: none;">?</div>
            <span class="infobox-button-specs-text">
              Meer info
            </span>
          </button>
        </div>
        <div class="card-info-size">
          <span class="card-info-size-text" >{{ description }}</span>
        </div>
      </div>

      <!-- VARIANTS -->
      <!-- <div class="card-options" v-if="data.variants && data.variants.length > 0"> -->
      <div class="card-options" v-if="computeCurrentVariants">        
        <button 
          v-for="(variant, index) in computeCurrentVariants" 
          :key="index"
          :class="cselected ? svariant.code === variant.code ? 'card-options-active' : '' : index === selectedVariant ? 'card-options-active' : ''"
          @click="selectedVariant = index; 
          selectedColor = 0; 
          selectedOption = 0; 
          lastCodeSelection = variant.code;
          $emit('select')"
          >
          <!-- ",{ 
            component: data, 
            glasTypeIndex: selectedGlasType,
            variantIndex: index, 
            colorIndex: 0, 
            optionIndex: 0 });"
        > -->
          {{ variant.name }}
        </button>
      </div>

      <!-- OPTIONS -->
      <!-- title = hover text over button -->
      <div class="card-options" v-if="data.options.length > 0">
        <button 
          v-for="(option, index) in data.options" 
          :key="index"
          :class="((selected ? option.selected : selectedOption === index) || allOptionsEnabled) ? 'card-options-active' : ''"    
          @click.stop="selectedOption = index; updateSelectedData()"
          >
          <!-- ,{ component: data, colorIndex: selectedColor, optionIndex: index })"
        > -->
          {{ option.name }}
        </button>
      </div>
    </div>
  </button>

  <Teleport to="body">
    <Transition name="fade">
      <div
        v-show="specsVisible"
        id="fullcoverD"
        @click="specsVisible = false"
      >              
        <div 
          :class="onMobile ? 'modalspecs modalspecs-size-mobile' : 'modalspecs modalspecs-size'"
          @click.stop=""
        >
            <button 
              class="modalclosebutton" 
              @mouseover="specsCloseBtnMouseOver" 
              @mouseleave="specsCloseBtnMouseLeave"
              @click="specsVisible = false"
            >
              <Transition name="closebtn">
                <div 
                  v-show="hasGlowingCloseBtn"
                  class="absolutepos glowingclose"
                />
              </Transition>
              <div>
                ×
              </div>
            </button>
          <!-- <div class="greyheader"> 
            {{ data.infobox.header }}
          </div> -->
          <div class="imagescroller">
            <img class="modalimage" :src="`/infoboximages/${infoboxes.find(info => info.id === infobox)?.urlEnding}`" alt="">
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script>
import { mapGetters } from 'vuex';

  export default {
    name: "ComponentCardD",

    props: {
      data: Object,
      selected: Boolean,
      cselected: Boolean,
      wSelected: Object, // selected wall data
      scolor: Object,
      soption: null,
      svariant: Object, // feature 1394
      sglasType: Object,

      imgUrl: String,
      title: String,
      description: String,
      infobox: String,
      infoboxOnline: String,
      colors: Array,
      allOptionsEnabled: Boolean,
      optionStartValue: Number,
      colorStartValue: String
    },

    data () {
      // console.log('component card data',this.data)
      return {
        models: import.meta.env.VITE_VUE_APP_MODELS_LOCATION,
        previewsServer: import.meta.env.VITE_VUE_APP_PREVIEWS_SERVER,
        selectedColor: 0,
        selectedOption: 0,
        selectedVariant: 0, // feature 1394
        selectedGlasType: 0, //
        lastCodeSelection: '', // for choosing .glb file
        specsVisible: false,
        hasGlowingInfoBtn: false,
        hasGlowingCloseBtn: false,
      }
    },

    computed: {
      ...mapGetters({
        glassAndVariantsData: 'getGlassAndVariantsData',
        infoboxes: 'getInfoboxes'
      }),
      computeDataForThisGlassType() {
        let targetCode = '';
        if (this.selectedGlasType) {
          targetCode = this.data.glasTypes[this.selectedGlasType].code
          // console.log('test glassAndVariantsData',this.glassAndVariantsData)
          return this.glassAndVariantsData[this.curCategory()].glassVariants
            .find(item => (item.code === targetCode && item.variants));
        } else return null;
      },
      computeCurrentVariants() {
        // Find "related" data for glass types and their variants when selecting glass.
        if (this.selectedGlasType) {
          const curData = this.computeDataForThisGlassType;
          if (curData) { 
            return curData.variants; 
          } else return [];
        // Otherwise, show data.variants (if any)
        } else if (this.data.variants && this.data.variants.length > 0) {
          return this.data.variants;
        } else return [];
      },
      computeDataForThisVariant() {
        let targetCode = '';
        if (this.selectedVariant) {
          targetCode = this.data.variants[this.selectedVariant].code
          return this.glassAndVariantsData[this.curCategory()].variantColors
            .find(item => (item.code === targetCode && item.colors));
        } else return null;
      },
      computeCurrentColors() {
        // Find "related" data for variants and their colors when selecting variant.
        if (this.selectedVariant) {
          const curData = this.computeDataForThisVariant;
          if (curData) { return curData.colors; } else return [];
        // Otherwise, show data.colors (if any)
        } else if (this.data.colors && this.data.colors.length > 0) {
          return this.data.colors;
        } else return [];
      },           
    },

    watch: {
      wSelected: "setCurrentComponentSettings",
      "data.options": {
        handler: "setSelectedOption",
        deep: true,
        immediate: true
      }
    },

    mounted() {
      this.setCurrentComponentSettings()

      if (this.optionStartValue) {
        this.selectedOption = this.optionStartValue;
      }

      if (this.colorStartValue) {
        this.selectedColor = this.colorStartValue;
      }
    },

    methods: {
      setSelectedOption() {
        if (this.selected) {
          this.selectedOption = this.data.options.findIndex(option => option.selected);
        }
      },
      setBackupImage(e, data) {
        e.target.src = `https://fakeimg.pl/400x400/?text=${data.code +  (data.options.length > 0 ? data.options[this.selectedOption].subCode : '')}&font=bebas`
      },
      curCategory() {
        // Find current category (for use in this.glassAndVariantsData.???.glassVariants etc)
        let result;
        switch(this.data.category) {
          case 'Deur': result = 'basicDoors'; break;
          case 'Raam': result = 'basicWindows'; break;          
          case 'Steellook Deur': result = 'steellookDoors'; break;
          case 'Steellook Raam': result = 'steellookWindows'; break;
          case 'Steellook Raam BW': result = 'steellookWindowsBW'; break;
          case 'Steellook': result = 'steellook'; break;
          case 'Steellook Wand BW': result = 'steellookWandBW'; break;
          case 'Schuifwand': result = 'slidingwall'; break;
        }
        return result;
      },

      setCurrentComponentSettings() {
        const colorIndex = this.computeCurrentColors.findIndex(item => item.code === this.scolor?.code);
        if(colorIndex > -1) this.selectedColor = colorIndex;
        const optionIndex = this.data.options ? this.data.options.findIndex(item => item.subCode === this.soption?.subCode) : -1;
        if(optionIndex > -1) this.selectedOption = optionIndex;
        const variantIndex = this.computeCurrentVariants.findIndex(item => item.code === this.svariant?.code);
        if(variantIndex > -1) this.selectedVariant = variantIndex;
        const glasTypeIndex = this.data.glasTypes ? this.data.glasTypes.findIndex(item => item.code === this.sglasType?.code) : -1;
        if(glasTypeIndex > -1) this.selectedGlasType = glasTypeIndex;
      },

      updateSelectedData(data = {}) {
        this.$emit('select', {
          selectedOption: this.selectedOption, 
          selectedColor: this.selectedColor,
          ...data
        })
      },
      specsBtnMouseOver() {
        this.hasGlowingInfoBtn = true;
      },
      specsBtnMouseLeave(){
        this.hasGlowingInfoBtn = false;
      },
      specsCloseBtnMouseOver() {
        this.hasGlowingCloseBtn = true;
      },
      specsCloseBtnMouseLeave(){
        this.hasGlowingCloseBtn = false;
      },
      enableAndHoldSpecs() {
        this.specsVisible = !this.specsVisible;
      }
    },
  }
</script>

<style lang="scss" scoped>

.card {
  display: flex;
  flex-grow: 1;
  height: calc(100% - 20px);
  flex-direction: column;
  border: 2px solid $c-border-1;
  border-radius: $radius-m;
  padding: 8px;
  transition: border-color 100ms ease;
  background-color: transparent;
  scroll-margin: 150px;

  &:hover {
    border-color: $c-secondary;
    cursor: pointer;
  }

  &-selected {
    border-color: $c-secondary;
  }

  &-header {
    display: flex;
    justify-content: space-between;
    max-width: 100%;

    // .image-container {
    //   width: calc(100% - 24px);
    //   aspect-ratio: 1;
    // }

    & img {
      width: 196px;
      aspect-ratio: 1;
      object-fit: contain;
      border-radius: $radius-m;

      @media (max-width: 999px) {
        width: 112px;
      }
    }

    &-colors {
      display: flex;
      flex-direction: column;
      gap: 8px;

      &-button {
        height: 32px;
        width: 32px;
        outline: 2px solid $c-border-1;
        outline-offset: -2px;
        border: none;
        border-radius: $radius-m;
        transition: outline-color 100ms ease;
        position: relative;
        cursor: pointer;
        margin-bottom: 16px;

        &:hover {
          outline-color: $c-secondary;
        }

        &-active {
          outline-color: $c-secondary;
        }

        & span {
          font-size: 9px;
          position:absolute;
          top: calc(100% + 2px);;
          left: 50%;
          transform: translateX(-50%);
          width: 200%;
        }
      }
    }

    &-glastypes {
      display: flex;
      flex-direction: column;
      gap: 6px;

      &-button {
        height: 24px;
        width: 32px;
        outline: 3px solid $c-border-1;
        outline-offset: -2px;
        border: none;
        border-radius: $radius-s;
        transition: outline-color 100ms ease;
        cursor: pointer;
        margin-right: 0.4em;

        &:hover {
          outline-color: $c-secondary;
        }

        &-active {
          outline-color: $c-secondary;
        }        
      }
    }
  }

  &-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin: 16px 0;

    &-header {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }

    & h3 {
      font-size: 19px;
      font-family: 'Oswald', sans-serif;
      text-transform: uppercase;
      text-align: left;
      @media (max-width: 999px) {
        font-size: 15px;
      }
    }

    &-size {
      display: flex;
      align-items: center;
      gap: 15px;
      font-weight: 500;

      &-text {
        font-weight: 400px;
      }
    }
  }

  &-options {
    display: flex;
    gap: 8px;

    & button {
      flex-grow: 1;
      background-color: $c-background-1;
      border: none;
      border-radius: 4px;
      font-weight: 400;
      font-size: 16px;
      height: 26px;
      color: $c-primary;
      transition: color 100ms ease, background-color 100ms ease;
      cursor: pointer;

      @media (max-width: 999px) {
        height: 48px;
      }
    }

    &-active {
      background-color: $c-primary !important;
      // color: $c-secondary  !important;
      color: $c-secondary-bright  !important;
    }
  }
}

.button-wrapper {
  border: none;
  display: flex;
  margin: 0px;
  padding: 0px;
  background-color: transparent;
  min-height: 100%;
}

.infobox {
  &-button-specs {
    cursor: pointer;
    display: flex;
    align-items: center;
    flex-direction: row;
    // position: absolute;
    margin-top: 4px;
    height: 23px;
    right: 0;
    padding: 3px;
    border-radius: $radius-l;
    border-style: none;
    background-color: $c-secondary; // babc16
    color: white; //$c-secondary-text;

    &-text {
      font-size: 0.8rem;
      padding: 0px 8px;
      padding-right: 16px;
      font-family: 'Source Sans 3', sans-serif !important;
      font-weight: 400px;
      text-wrap: nowrap;

      @media (max-width: 999px) {
        padding-right: 8px;
      }
    }
  }

  &-question-mark {
    // padding: 5px 10px;
    padding: 0px 5px;
    border-radius: $radius-l;
    font-weight: bold;
    font-size: 0.7rem;    
    color: white;
    background-color: $c-primary;
  }
}




#fullcoverD {
  position: fixed;
  z-index: 998;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
}
.modalspecs {
  position: fixed;
  z-index: 999;
  // top: 10%;
  left: 50%;
  // width: 30rem;
  // margin-left: -15rem;
  // height: 80vh;
  background-color: white;
  border-radius: $radius-s;
}
.modalspecs-size {
    top: 3%;
    width: 36rem;
    margin-left: -18rem;
    height: 94vh;
 }
.modalspecs-size-mobile {
    top: 10%;
    width: 98%;
    margin-left: -49%;
    height: 80vh;
 }

.modaltopcontainer {
  display: flex; text-align: start; height: 8vh
}
.modaltopcontainer h3 {
  margin: 1.5vh 1.5vh 1.5vh 3vh;
}
// .greyheader {
//   color: $c-secondary;
//   background-color: $c-primary; 
//   border-radius: 5px; 
//   margin: 0px 10px 10px 10px; 
//   font-size: x-large;
//   text-align: center; 
// }

.imagescroller {
  // max-height: calc(85% - 1px); // a trick to force a scroll area to appear despite fixed position
  max-height: calc(98%); // minus size of modaltopcontainer
  overflow-y: auto;
  border-radius: $radius-m;
}
.modalimage {
  width: 100%;
  height: auto;
}

.modalclosebutton {
  position: absolute;
  // margin-left: auto;
  top: 32px;
  right: 48px;
  height: 4vh;
  width: 4vh;
  background: transparent;
  color: white;
  border: 2px solid white;
  box-sizing: border-box;
  border-radius: 3vh;
  // padding: 0px 10px 0px 10px;
  font-size: 4vh;
  pointer-events: all;
  cursor: pointer;
  // force the × to stay centered despite resizing
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.5s ease;

  &:hover {
    background-color: rgba(255, 255, 15, 0.75);
  }
}

</style>